import React, { KeyboardEvent, useState } from 'react';
import './styles.scss';
import Chip from '../chip';

type Props = {
  label?: string;
  placeholder?: string;
  values?: string[];
  validate?: (value: string) => boolean;
  onChange?: (value: string) => true | void;
  onEnter?: (value: string) => void;
  onDelete?: (value: string) => void;
};

const MultiInput = (props: Props) => {
  const { label, placeholder, values, onEnter, onDelete, validate, onChange } = props;
  const [value, setValue] = useState('');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (!value) return;
    if (e.key === 'Enter' && onEnter) {
      onEnter(value);
      setValue('');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (validate) {
      if (validate(e.target.value)) {
        setValue(e.target.value);
        if (onChange) {
          const clearInput = onChange(e.target.value);
          if (clearInput && e.target.value) setValue('');
        }
      }
    } else {
      setValue(e.target.value);
      if (onChange) {
        const clearInput = onChange(e.target.value);
        if (clearInput && e.target.value) setValue('');
      }
    }
  };

  return (
    <div className='multiinput'>
      {label ? <p className='multiinput__label'>{label}</p> : null}
      <div>
        {values?.map((value, i) => (
          <Chip
            key={i}
            text={value}
            onClick={(e) => {
              e?.stopPropagation();
              onDelete?.(value);
            }}
            showDeleteIcon
          />
        ))}
        <input
          type='text'
          placeholder={placeholder}
          className='multiinput__input'
          value={value}
          onKeyDown={handleKeyDown}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

export default MultiInput;
